import { useFormikContext } from "formik";
import { TaskCreate } from "@common/contracts/task.contract";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import fieldStyles from "./TaskDrawerFields.module.scss";
import { TaskSplit, getTaskSplit } from "./taskWorkflow";

interface TaskSplitFieldProps {
    transactionSplitBlocker: string | null;
}

export const TaskSplitField = ({
    transactionSplitBlocker,
}: TaskSplitFieldProps) => {
    const formik = useFormikContext<TaskCreate>();

    const items: Array<PickerItemData<TaskSplit>> = [
        { value: TaskSplit.ENTITY, label: "Entity" },
        {
            value: TaskSplit.TRANSACTION,
            label: "Transaction",
            disabled: transactionSplitBlocker !== null,
            disabledReason: transactionSplitBlocker ?? undefined,
        },
    ];

    return (
        <DescriptionListItem label="Split on">
            <div className={fieldStyles.detailSelectWrapper}>
                <Picker.Select
                    items={items}
                    value={getTaskSplit(formik.values)}
                    onValueChange={(split) =>
                        void formik.setFieldValue(
                            "createTaskPerTransaction",
                            split === TaskSplit.TRANSACTION,
                        )
                    }
                    trigger={
                        <Picker.Button
                            variant="primary"
                            className={fieldStyles.detailSelectTrigger}
                        />
                    }
                />
            </div>
        </DescriptionListItem>
    );
};
